// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"95":"2baecd55","112":"959b5cfb","140":"1eaa1ed8","441":"08ff1b3d","676":"40005afe","697":"96584a12","879":"c2eb6c2e"}[chunkId] + ".js";
};